<template lang="html">
   <div class="fx-wizard">
      <div class="wizard-head clearfix">
         <div 
            class="head-content clearfix"  
            v-if="forms && forms.length > 0" 
            v-for="i in forms.length" 
            :data-tag="i -= 1"
            :class="{'active': current === (i-1)}"
         >
            <div class="icon l" :class="forms[i].icon || 'fa fa-user'"></div>
            <div class="w-content l">
               <div class="fx-h6">{{forms[i].title}}</div>
               <div class="text-muted">{{forms[i].subtitle}}</div>
            </div>
         </div>
      </div>
      <div class="wizard-pages">
         <div class="wizard-page" v-if="forms && forms.length > 0" v-for="i in forms.length">
            <span v-show="false">{{i -= 1}}</span>

            <div class="page-content" v-show="current === i">
               <Form 
                  v-if="forms && forms[i].forms"
                  class_binding="row" 
                  :ref="forms[i].name" 
                  :forms="forms[i].forms" 
                  :form_data="forms[i].data"
               />
            </div>
         </div>
      </div>
      <div class="wizard-actions clearfix">
         <div class="btn l" v-show="current > 0" @click="previousPage">Previous</div>
         <div class="btn btn-primary r" v-show="current < forms.length-1" disabled="isLoading" @click="nextPage">
            Next
            <div class="lds-ring" v-show="isLoading"><div></div><div></div><div></div><div></div></div>
         </div>
         <div class="btn btn-primary r" v-show="current === forms.length-1" disabled="isLoading" @click="submit">
            Finish
            <div class="lds-ring" v-show="isLoading"><div></div><div></div><div></div><div></div></div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   components:{
      Form: () => import("./form"),
   },
   props:{
      forms:{
         type: Array,
         default: function(){
            return []
         }
      },
      loading: {
         type: [Boolean, Number],
         default: false
      },
      reset:{
         type: [Boolean, Number],
         default: false
      },
      resetPage:{
         type: [Boolean, Number],
         default: false
      }
   },
   watch: {
      loading(){
         this.isLoading = this.loading
      },
      reset(newVal){
         if(newVal){
            this.resetWizard()
         }
      },
      resetPage(newVal){
         if(newVal){
            this.current = 0
         }
      },
   },
   data () {
      return {
         current: 0,
         isLoading: this.loading,
         data: {},
         isReset: this.reset
      }
   },
   methods: {
      previousPage() {
         if(this.current > 0){
            this.current--
            this.$emit('previous_page',{currentPage: this.current,data: this.data})
         }
      },
      async nextPage() {
         if(this.current >= 0 && this.current < this.forms.length){
            let form_name = this.forms[this.current].name
            let isValid = await this.$refs[form_name][0].isValid()
            
            if(isValid){
               let form_data = this.$refs[form_name][0].form_data_
               this.data = Object.assign({},this.data, form_data)

               this.current++
               this.$emit('next_page',{current_page: this.current,data: this.data})
            }
         }
      },
      async submit(){
         let form_name = this.forms[this.current].name
         let isValid = await this.$refs[form_name][0].isValid()
            
         if(isValid){
            let form_data = this.$refs[form_name][0].form_data_
            this.data = Object.assign({},this.data, form_data)
            this.$emit('submit-form',{current_page: this.current,data: this.data})
         }
      },
      async resetWizard(){
         for (let i = 0; i < this.forms.length; i++) {
            let form_name = this.forms[i].name
            await this.$refs[form_name][0].resetForms()
         }
         
         this.data = {}
         this.current = 0
         this.reset = false
      }
   },
}
</script>